import '../../scss/bet-value-menu.scss'
import React, { Component } from 'react'
import gsap from 'gsap';
import {LiveMenuState} from './LiveRound'
import {liveMenuDescriptionHeight , buttonHeight} from '../../utils/constants'

interface BetMenuProps {
    betValue: number;
    isMobile:boolean;
    showBetValueModalHandler:(value : boolean)=>void;
}

export default class BetValueMenu extends Component<BetMenuProps>{

    mainDiv = React.createRef<HTMLDivElement>();

    componentDidMount = () =>{
        this.lowerContent(LiveMenuState.close , 0);
    }

    show = () => {
        gsap.to(this.mainDiv.current, {
            opacity: 1,
            duration: 0.1
        })
    }

    hide = () => {

        gsap.to(this.mainDiv.current, {
            opacity: 0,
            duration: 0.1
        })
    }

    lowerContent = (liveMenuState : LiveMenuState , time : number = 0.5)=>{

        const btHeightPer = ((20 / window.innerHeight) * 100) * 1.5;
        const liveHeightPer = ((liveMenuDescriptionHeight / window.innerHeight) * 100);

        let bottom = buttonHeight - btHeightPer;
        if(liveMenuState === LiveMenuState.open)
            bottom -= liveHeightPer;
    }

    render() {
        return (
            <div ref={this.mainDiv} className={this.props.isMobile ? "bet-value-menu" : "bet-value-menu-desktop" } onClick={()=>{this.props.showBetValueModalHandler(true)}}>
                <p>{`Bet $${this.props.betValue}`}</p>
            </div>
        )
    }


}

